// extracted by mini-css-extract-plugin
export var bodyRow = "_cz-d";
export var cardColumns = "_cz-e";
export var ellipsesOverflow = "_cz-2";
export var flatBottomCorners = "_cz-3";
export var flatTopCorners = "_cz-4";
export var headerActionsDropdown = "_cz-f";
export var headerBottomRow = "_cz-c";
export var headerTopRow = "_cz-b";
export var orderDetailsWrapper = "_cz-0";
export var orderInfoContainer = "_cz-1";
export var productDetails = "_cz-9";
export var productImage = "_cz-5";
export var responsiveTable = "_cz-8";
export var shipmentContainer = "_cz-a";
export var tableBottomLeft = "_cz-6";
export var tableBottomRight = "_cz-7";
export var trackingLink = "_cz-g";